import React, { useState, useEffect } from "react";
import { useLocation, useParams, Link } from "react-router-dom";
import useAxiosIntercept from "../../hooks/useAxiosIntercept";
import UpComingBookings from "./UpComingBookings";
import PastBookings from "./PastBookings";
import VehicleDetails from "./VehicleDetails";
import PersonalDetails from "./PersonalDetails";
import Image from "../UI/Image";
import { FormatDate } from "../../utils/FormatDate";
import VechicleListing from "./VechicleListing";

const   CustomerDetails = () => {
  const params = useParams();
  const axiosPrivate = useAxiosIntercept();
  const [userDetails, setUserDetails] = useState([]);
  // const [showSubComponent, setshowSubComponent] = useState({
  //   upComingBookings: true,
  // });

  // const handler = (e) => {
  //   setshowSubComponent({ [e.target.id]: true });
  // };
  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const getuserDetalis = async () => {
      const URL = process.env.REACT_APP_GET_SINGLE_USER;
      try {
        const response = await axiosPrivate.get(
          URL + `&user_id=${params.user_id}&user_type=C&show_booking_info=1`,
          {
            signal: controller.signal,
          }
        );
        if(response?.data?.response?.data?.user_info){
          isMounted && setUserDetails(response?.data?.response?.data?.user_info);
        }
        // isMounted && setUserDetails(response?.data?.response?.data?.user_info);
      } catch (err) {
        //console.error(err);
      }
    };

    getuserDetalis();

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <>
      {
        <div className="boxType1 bgBox2 customersDetails">
          {
            <>
              <div className="userInfo big mr-0">
                {userDetails?.user_image != null ?
                    <Image
                      userImage={userDetails.user_image}
                      name={userDetails.firstname?userDetails.firstname:"Guest"}
                    />
                :
                  <Image
                    userImage=""
                    name={userDetails.firstname?userDetails.firstname:"Guest"}
                  />
                }
                <div className="name">
                  {userDetails.firstname?<span>{userDetails.firstname + " " + userDetails.lastname}</span>:<span>Guest</span>}

                  {userDetails.created_at && <span>
                    Active since: {FormatDate(userDetails.created_at)}
                  </span>}
                </div>
                {/*<div className="actionNav wBorder">*/}
                {/*  <i className="material-symbols-rounded mt-m grey">*/}
                {/*    more_vert*/}
                {/*  </i>*/}
                {/*  <div className="dropMenuWrap">*/}
                {/*    <ul className="dropMenu" style={{width:"180px"}}>*/}
                {/*      <li>*/}
                {/*        <a href="javascript:void(0);" className="open_model">*/}
                {/*          Assign a promo*/}
                {/*        </a>*/}
                {/*      </li>*/}
                {/*    </ul>*/}
                {/*  </div>*/}
                {/*</div>*/}
                <div className="nextLine socialLinks">
                  <p>
                    <i className="material-symbols-rounded mt-s grey">mail</i>
                    {userDetails.email == "" ? (
                      <>
                        <Link to="">NA</Link>
                      </>
                    ) : (
                      <>
                        <Link to="">{userDetails.email}</Link>
                      </>
                    )}
                  </p>
                  <p>
                    <i className="material-symbols-rounded mt-s grey">call</i>
                    {userDetails.phone == "" || userDetails.phone == 0 ? (
                      <>
                        <Link to="">NA</Link>
                      </>
                    ) : (
                      <>
                        <Link to="">{userDetails.phone}</Link>
                      </>
                    )}
                  </p>
                </div>
              </div>
              <div className="xRow pt-24 pb-12 dashboard mb-24">
                {/*<div className="boxT1">*/}
                {/*  <p>Total bookings</p>*/}
                {/*  {userDetails?.booking_info ?*/}
                {/*    <span>{userDetails?.booking_info.total_count}</span>*/}
                {/*      :*/}
                {/*    <span>N/A</span>*/}
                {/*  }*/}
                {/*</div>*/}
                {/*<div className="boxT1">*/}
                {/*  <p>Energy used till date</p>*/}
                {/*  <span>4098 kWH</span>*/}
                {/*</div>*/}
              </div>
              {/*<div className="navTabs mt-24 mb-24">*/}
              {/*  <ul className="level1">*/}
              {/*    <li*/}
              {/*      className={*/}
              {/*        showSubComponent.upComingBookings ? "selected" : ""*/}
              {/*      }*/}
              {/*    >*/}
              {/*      <Link id="upComingBookings" onClick={handler}>*/}
              {/*        Upcoming bookings*/}
              {/*      </Link>*/}
              {/*    </li>*/}
              {/*    <li*/}
              {/*      className={showSubComponent.pastBookings ? "selected" : ""}*/}
              {/*    >*/}
              {/*      <Link id="pastBookings" onClick={handler}>*/}
              {/*        Past bookings*/}
              {/*      </Link>*/}
              {/*    </li>*/}
              {/*    <li*/}
              {/*      className={*/}
              {/*        showSubComponent.vehicleDetails ? "selected" : ""*/}
              {/*      }*/}
              {/*    >*/}
              {/*      <Link id="vehicleDetails" onClick={handler}>*/}
              {/*        Vehicle details*/}
              {/*      </Link>*/}
              {/*    </li>*/}
              {/*    <li*/}
              {/*      className={*/}
              {/*        showSubComponent.personalDetails ? "selected" : ""*/}
              {/*      }*/}
              {/*    >*/}
              {/*      <Link id="personalDetails" onClick={handler}>*/}
              {/*        Personal details*/}
              {/*      </Link>*/}
              {/*    </li>*/}
              {/*  </ul>*/}
              {/*</div>*/}
              {/*<VehicleDetails />*/}

              <VechicleListing user_id={params.user_id} name={userDetails.firstname}/>
            </>
          }
        </div>
      }
    </>
  );
};

export default CustomerDetails;
